import { AbstractAdSetupFactory } from 'tag/ts/tag/factories/ads/AbstractAdSetupFactory';
import { AdSDK } from 'tag/ts/tag/model/type/ads/AdSDK';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
import { AdSetupType } from 'tag/ts/tag/model/type/ads/AdSetupType';
export class DesktopAdSetupFactory extends AbstractAdSetupFactory {
    constructor(argument) {
        super({
            name: 'DesktopAdSetupFactory',
            ...argument
        });
    }
    createAdSetupInfo() {
        if (this.utils.Type.isEmpty(this.tag)) {
            this?.logger?.warn('createAdSetupInfo', 'tag is empty, cannot create adSetupInfo... exiting');
            return;
        }
        const tagConfig = this.tag?.model?.config?.tag;
        const contentUtilities = this.tag?.model?.contentUtilities;
        const tagUtilities = this.tag?.tagUtilities;
        const params = this.tag?.params;
        const apiMetadata = this.tag?.model?.apiMetadata;
        const isLive = contentUtilities.isLive(params, apiMetadata);
        const isPID = contentUtilities.isPID(this.tag);
        const isLiveDAIStream = contentUtilities.isLiveDAIStream(apiMetadata);
        const hasDAIAssetKey = contentUtilities.hasDAIAssetKey(params, apiMetadata);
        const isAssetURL = contentUtilities.isAssetURL(this.tag);
        const isInternational = tagUtilities.isInternationalContext(this.tag) === true;
        const videoAdsDisabled = params?.AD?.VIDEOADS?.enabled === false;
        const isLinearAdTrackable = contentUtilities.isLinearAdTrackable();
        const adSetupInfo = this.createDefaultAdSetupInfo();
        this?.logger?.log('createAdSetupInfo', 'created default adSetupInfo object requiring no ads:', adSetupInfo);
        if (isLinearAdTrackable) {
            adSetupInfo.setup.definition = AdSetupDefinition.LINEAR_AD_TRACKING;
            this?.logger?.log('createAdSetupInfo', 'is linear ad trackable... updated setup definition:', adSetupInfo);
            return adSetupInfo;
        }
        if (isInternational && videoAdsDisabled) {
            this?.logger?.log('createAdSetupInfo', 'is INTL context, VIDEOADS is disabled... no ad setup required:', adSetupInfo);
            return adSetupInfo;
        }
        if (isAssetURL && isLive) {
            this?.logger?.log('createAdSetupInfo', 'asset is livestream, playback via assetUrl... no ad setup required:', adSetupInfo);
            return adSetupInfo;
        }
        if (isLive && isPID && hasDAIAssetKey && isLiveDAIStream) {
            adSetupInfo.setup.type = AdSetupType.SSAI;
            adSetupInfo.setup.definition = AdSetupDefinition.DAI_SDK;
            adSetupInfo.sdk.type = AdSDK.IMA_DAI;
            adSetupInfo.sdk.module = tagConfig?.Imports?.params?.ad_sdk[adSetupInfo.sdk.type];
            this?.logger?.log('createAdSetupInfo', 'asset is DAI livestream, playback via PID... setup ad playback via SSAI with DAI SDK:', adSetupInfo);
            return adSetupInfo;
        }
        if (isLive && isPID && !isLiveDAIStream) {
            adSetupInfo.setup.type = AdSetupType.SSAI;
            adSetupInfo.setup.definition = AdSetupDefinition.DAI_SSB;
            adSetupInfo.sdk.type = AdSDK.NONE;
            adSetupInfo.sdk.module = undefined;
            this?.logger?.log('createAdSetupInfo', 'asset is DAI SSB livestream, playback via PID... setup ad playback via SSAI with DAI SSB, resolving:', adSetupInfo);
            return adSetupInfo;
        }
        if (!isLive && isPID) {
            adSetupInfo.setup.type = AdSetupType.SSAI;
            adSetupInfo.setup.definition = AdSetupDefinition.DAI_SDK;
            adSetupInfo.sdk.type = AdSDK.IMA_DAI;
            adSetupInfo.sdk.module = tagConfig?.Imports?.params?.ad_sdk[adSetupInfo.sdk.type];
            this?.logger?.log('createAdSetupInfo', 'asset is VOD, playback via PID... setup ad playback via SSAI with DAI SDK, resolving:', adSetupInfo);
            return adSetupInfo;
        }
        this?.logger?.log('createAdSetupInfo', 'no matching use case, returning default adSetupInfo:', adSetupInfo);
        return adSetupInfo;
    }
}
